import { render, staticRenderFns } from "./grupaSLA.vue?vue&type=template&id=0832cbb8&scoped=true&"
import script from "./grupaSLA.vue?vue&type=script&lang=js&"
export * from "./grupaSLA.vue?vue&type=script&lang=js&"
import style0 from "./grupaSLA.vue?vue&type=style&index=0&id=0832cbb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0832cbb8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0832cbb8')) {
      api.createRecord('0832cbb8', component.options)
    } else {
      api.reload('0832cbb8', component.options)
    }
    module.hot.accept("./grupaSLA.vue?vue&type=template&id=0832cbb8&scoped=true&", function () {
      api.rerender('0832cbb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/general/grupaSLA.vue"
export default component.exports